import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

const getButtonColor = (type: string) => {
  switch (type) {
    case 'facebook':
      return '#2665b7'
    default:
      return '#3aac6b'
  }
}

interface StyledShareDisplayContainerProps {
  $isModal: boolean;
}
export const StyledShareDisplayContainer = styled.div<StyledShareDisplayContainerProps>`
  position: relative;
  margin: ${({ $isModal }) => $isModal ? 0 : '20px'};
`;

export const StyledShareControlContainer = styled.div`
  padding: 1rem 1rem 1rem;
  border-radius: 0;
`;

export const StyledShareReturnButton = styled.button`
	display: flex;
  align-items: center;
  height: auto;
  font-size: 1rem;
  font-weight: 600;
  color: rgb(238, 238, 238);
  background-color: black;
  border: 0.125rem solid white;
  border-radius: 100%;
  padding: 0.625rem;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  outline: none;
`;

export const StyledShareContentContainer = styled.div`
	background-color: black;
  color: white;
	height: 100%;
`;

export const StyledShareImg = styled.img`
  max-height: 18.75rem;
  max-width: 100%;
  object-fit: contain;
  margin: auto;
`;

export const StyledShareConsentFormContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background-color: black;
  padding: 0 1.75rem;
  border-radius: 0;
`;

export const StyledShareTitle = styled.h1`
  margin: 2.5rem 0;
  color: white;
`;

export const StyledShareForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  label {
    position: relative;
    display: flex;
    flex-direction: row;
    cursor: pointer;
    margin-left: 0.625rem;
    
    input[type="checkbox"] {
      appearance: none;
      width: 1.25rem;
      height: 1.25rem;
      border: 2px solid white;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      cursor: pointer;
      position: relative;
      margin-right: 5px!important;
    }
    
    input[type="checkbox"]:checked::before {
      content: "✔";
      color: #34b076;
      font-size: 1rem;
      font-weight: bold;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
		
	a {
		margin: 0.625rem 0px 1.25rem;
    
		svg {
      height: 1.25rem;
      width: 1.25rem;
		}
	}
`;

export const StyledShareSectionButton = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100%;
`;

export const StyledShareErrorMessage = styled.span`
  color: #fe0045;
  margin-bottom: 20px;
`;

export const StyledShareSpinnerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background-color: black;
  border-radius: 0;
	justify-content: center;
`;

export const StyledShareLoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const StyledShareLinksContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: white;
  background-color: black;
  padding: 0 3.75rem 3.75rem 3.75rem;
  border-radius: 0;
`;

interface StyledShareConsentButtonProps {
  theme: any;
}
export const StyledShareConsentButton = styled.button<StyledShareConsentButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  color: white;
  padding: 0.75rem;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: ${({ theme }) => pxToRem(theme.button_radius || 0)};
  box-shadow: none;
  transition: 0.2s cubic-bezier(0.25, 0.1, 0.25, 0.1);
  cursor: pointer;
  margin: auto;
  
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    pointer-events: none;
    font-weight: 700;
    ${({ theme }) => theme.button_font && css`font-family: ${theme.button_font};`};
  }

  &:not(:disabled)&:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  }

  &:disabled {
    background-color: lightgray;
    border: 2px solid lightgray;
  }
`;

interface StyledShareButtonContainerProps {
  $isSpinner: boolean;
}
export const StyledShareButtonContainer = styled.div<StyledShareButtonContainerProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${pxToRem(10)} 0;
  width: 100%;

  &:first-of-type {
    margin: ${({ $isSpinner }) => ($isSpinner ? `${pxToRem(30)} 0` : `0 ${pxToRem(10)} ${pxToRem(10)}`)};
  }
`;

interface StyledShareButtonProps {
  theme: any;
  $type: string;
}
export const StyledShareButton = styled.button<StyledShareButtonProps>`
  color: white;
  background-color: ${({ $type }) => getButtonColor($type)};
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${pxToRem(10)} ${pxToRem(30)} ${pxToRem(10)} 0;
  border-radius: ${pxToRem(3)};
  outline: none;
  border: none;
  cursor: pointer;

  i {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    padding: 0 ${pxToRem(20)};
    position: relative;

    svg {
      width: ${pxToRem(20)};
      height: ${pxToRem(20)};
    }

    &:after {
      content: '';
      width: ${pxToRem(1)};
      height: 100%;
      position: absolute;
      top: 0;
      right: ${pxToRem(-15)};
      background-color: white;
    }
  }

  a {
    margin: 0;
  }

  label {
    padding-left: ${pxToRem(30)};
    text-align: start;
    cursor: pointer;
  }
`;

interface StyledShareButtonLinkProps {
  theme: any;
  $type: string;
}
export const StyledShareButtonLink = styled.a<StyledShareButtonLinkProps>`
  color: white;
  background-color: ${({ $type }) => getButtonColor($type)};
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${pxToRem(10)} ${pxToRem(30)} ${pxToRem(10)} 0;
  border-radius: ${pxToRem(3)};
  outline: none;
  border: none;
  cursor: pointer;

  i {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    padding: 0 ${pxToRem(20)};
    position: relative;

    svg {
      width: ${pxToRem(20)};
      height: ${pxToRem(20)};
    }

    &:after {
      content: '';
      width: ${pxToRem(1)};
      height: 100%;
      position: absolute;
      top: 0;
      right: ${pxToRem(-15)};
      background-color: white;
    }
  }

  a {
    margin: 0;
  }

  label {
    padding-left: ${pxToRem(30)};
    text-align: start;
    cursor: pointer;
  }
`;
